interface Props {
  totalOwed: number;
  totalPaid: number;
  totalBalance: number;
}

export default function SummaryCards({ totalOwed, totalPaid, totalBalance }: Props) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
      <div className="bg-white rounded-xl p-5 border border-slate-200">
        <p className="text-slate-400 text-xs uppercase tracking-wider mb-2">Total Booked</p>
        <p className="text-[#0f172a] text-2xl font-bold">${totalOwed.toLocaleString()}</p>
      </div>
      <div className="bg-white rounded-xl p-5 border border-slate-200">
        <p className="text-slate-400 text-xs uppercase tracking-wider mb-2">Amount Paid</p>
        <p className="text-2xl font-bold text-emerald-500">
          ${totalPaid.toLocaleString()}
        </p>
      </div>
      <div className="bg-white rounded-xl p-5 border border-slate-200">
        <p className="text-slate-400 text-xs uppercase tracking-wider mb-2">Balance Due</p>
        <p
          className={`text-2xl font-bold ${
            totalBalance > 0 ? "text-amber-500" : "text-emerald-500"
          }`}
        >
          ${totalBalance.toLocaleString()}
        </p>
      </div>
    </div>
  );
}
